import { Progress } from 'antd';
import React, { FC } from 'react';
import { IItemProgressData } from '@/presentation/pages/traffic/issues/list/statistical-distribution/item';
import styles from './index.module.scss';

export interface ProgressItemProp {
  strokeColor?: string;
  record: IItemProgressData;
  labelWidth?: number;
  /** 机型 → 营销名称映射（非 model 维度不会传入） */
  marketingNameMap?: Record<string, string>;
}

export const ProgressItem: FC<ProgressItemProp> = (props) => {
  const { record, marketingNameMap } = props;
  const marketingName = marketingNameMap?.[record.field];

  return (
    <div
      className={styles.progress}
      data-record={JSON.stringify(record)}
      onMouseEnter={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <span className={styles.metricName} style={{
        maxWidth: props.labelWidth,
      }}>
        {record.field}
        {marketingName ? <span style={{ color: '#999' }}>{` (${marketingName})`}</span> : null}
      </span>
      <Progress
        className={styles.progressItem}
        percent={record.valueRatio * 100}
        strokeColor={props.strokeColor}
        format={() => null}
      />
    </div>
  );
};
